/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Upload_TextInputs */

const en_dialog_text_to_audio_upload_text = /** @type {(inputs: Dialog_Text_To_Audio_Upload_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload`)
};

const es_dialog_text_to_audio_upload_text = /** @type {(inputs: Dialog_Text_To_Audio_Upload_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir`)
};

/**
* | output |
* | --- |
* | "Upload" |
*
* @param {Dialog_Text_To_Audio_Upload_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_upload_text = /** @type {((inputs?: Dialog_Text_To_Audio_Upload_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Upload_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_upload_text(inputs)
	return en_dialog_text_to_audio_upload_text(inputs)
});